import React from 'react';
import { styled } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { Link } from 'react-router-dom';
import MuiLink from '@mui/material/Link';
import usePromise from 'hooks/usePromise';

const StyledButton = styled(IconButton)`
  border-radius: ${(props) => (props.rounded ? '50%' : '4px')};
  padding: 4px 8px;
  transition: all 0.2s ease-in;
  background-color: ${(props) =>
    props.active ? props.theme.palette.action.selected : 'transparent'};
  border: none;
  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
  &:focus {
    outline: none;
  }
`;

const LoadingIconButton = ({
  icon,
  to,
  href,
  title,
  loading,
  onClick,
  ...rest
}) => {
  const [isLoading, handler] = usePromise(onClick, loading);

  let children = (
    <IconButton onClick={handler} color="inherit" size="medium" {...rest}>
      {isLoading ? <CircularProgress size={12} /> : icon}
    </IconButton>
  );

  if (title) {
    children = (
      <Tooltip arrow title={title}>
        {children}
      </Tooltip>
    );
  }

  if (to) {
    return (
      <MuiLink component={Link} to={to} {...rest}>
        {children}
      </MuiLink>
    );
  } else if (href) {
    return (
      <MuiLink href={href} {...rest}>
        {children}
      </MuiLink>
    );
  }
  return children;
};

export default LoadingIconButton;
